import { AttachmentCore } from './Core'
import { AttachmentCardProps } from './interface'
import { AttachmentCardStoreProvider } from './Store'
import { AttachmentSynchorizner } from './Synchorizner'

export const AttachmentCard = (props: AttachmentCardProps) => {
  return (
    <AttachmentCardStoreProvider {...props}>
      <AttachmentCore />
      <AttachmentSynchorizner />
    </AttachmentCardStoreProvider>
  )
}
